import { BrandLogo } from '@/components/common/BrandLogo';
import { NotificationBell } from '@/components/common/NotificationBell';
import { WorkspaceSwitcher } from '@/components/layout/WorkspaceSwitcher';
import { useAuth } from '@/hooks/useAuth';
import { ClientAccountMenu } from './ClientAccountMenu';

export function ClientShellHeader() {
  const { memberships } = useAuth();
  const hasMultipleWorkspaces = memberships.length > 1;

  return (
    <header className="bg-zoowhite border-b border-zooborder shrink-0">
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 md:px-8 py-3 flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <BrandLogo className="h-7 w-auto object-contain shrink-0" />
          {hasMultipleWorkspaces === true ? (
            <div className="max-w-44 w-full min-w-0">
              <WorkspaceSwitcher tone="light" />
            </div>
          ) : null}
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <NotificationBell />
          <ClientAccountMenu />
        </div>
      </div>
    </header>
  );
}
